"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EpsilonRepeaterRow = /** @class */ (function () {
    /**
     * Row Constructor
     * @param {{container: JQuery; setting: void; params: {value: number; id: string}}} instance
     * @param {JQuery} rowContainer
     */
    function EpsilonRepeaterRow(instance, rowContainer) {
        var self = this;
        this.index = instance.currentIndex;
        this.container = rowContainer;
        this.label = this.getLabel(instance);
        this.header = this.container.find('.repeater-row-header');
        this.footer = this.container.find('.repeater-row-footer');
        this.handleEvents(instance);
        instance.utils.updateLabel(this);
    }
    /**
     *
     * @returns {any}
     */
    EpsilonRepeaterRow.prototype.getLabel = function (instance) {
        return instance.control.params.rowLabel;
    };
    /**
     * Handle row events
     */
    EpsilonRepeaterRow.prototype.handleEvents = function (instance) {
        var control = instance, self = this;
        /**
         * Click event on header to toggle minimize
         */
        this.header.on('click', function () {
            control.utils.toggleMinimize(self);
        });
        /**
         * Click event on handler to toggle minimize
         */
        this.container.on('click', '.repeater-row-minimize', function () {
            control.utils.toggleMinimize(self);
        });
        /**
         * Remove row functionality
         */
        this.container.on('click', '.repeater-row-remove', function () {
            control.utils.removeRow(self);
        });
        /**
         * Update row functionality
         */
        this.container.on('keyup change', 'input, select, textarea', function (e) {
            control.utils.updateField(self, jQuery(e.target).data('field'), e.target);
            control.utils.updateLabel(self);
            self.container.trigger('row:update', [self.index, jQuery(e.target).data('field'), e.target]);
        });
    };
    return EpsilonRepeaterRow;
}());
exports.EpsilonRepeaterRow = EpsilonRepeaterRow;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/repeater/repeater-row.ts
// module id = 8
// module chunks = 0